export const adaptAEResumen = (data) => {
    const { idComboRIValorModoInfusionAE,
        idComboRIValorModoInfusionAENavigation,
        idComboRIValorTipoAccesoAENavigation,
        idComboRIValorKarnofskyNavigation,
        proteinasTotales,
        caloriasTotales,
        ...aeData } = data;
    return {
        ...aeData,
        proteinasTotalesAE: proteinasTotales,
        caloriasTotalesAE: caloriasTotales,
        comboRIValorTipoAccesoAE: idComboRIValorTipoAccesoAENavigation?.valor,
        comboRIValorModoInfusionAE: idComboRIValorModoInfusionAENavigation?.valor,
        comboRIValorKarnofskyAE: idComboRIValorKarnofskyNavigation?.valor
    }
}